import { KeyboardArrowDownRounded } from '@mui/icons-material';
import {
    Button,
    ButtonGroup,
    Divider,
    Menu,
    MenuItem,
    MenuItemProps,
} from '@mui/material';
import { ButtonProps } from '@react-email/components';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type MenuItemButtonProps = MenuItemProps & ButtonProps;

export interface ButtonOptionProps extends MenuItemButtonProps {
    label: string;
    selected?: boolean;
}

interface SplitButtonProps {
    options: ButtonOptionProps[];
}

const SplitButton: React.FC<SplitButtonProps> = ({ options = [] }) => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef();
    const { label, ...selectedProps } = options.find(
        option => option?.selected,
    );

    return (
        <>
            <ButtonGroup
                ref={ref}
                variant="contained"
                size="large"
                disableElevation
            >
                <Button {...selectedProps}>{label}</Button>
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ borderColor: 'transparent' }}
                />
                <Button
                    onClick={() => setOpen(true)}
                    sx={{
                        padding: 0,
                    }}
                >
                    <KeyboardArrowDownRounded />
                </Button>
            </ButtonGroup>
            <Menu
                open={open}
                onClose={() => setOpen(false)}
                anchorEl={ref?.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: i18n.dir() === 'rtl' ? 'left' : 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: i18n.dir() === 'rtl' ? 'left' : 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: 4,
                            minWidth: ref.current?.clientWidth,
                        },
                    },
                }}
            >
                {options.map(({ label, ...rest }) => (
                    <MenuItem key={label} {...rest}>
                        {label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default SplitButton;
